// Rooms stay open while the host gathers players. This is an internal safety
// ceiling, not a choice players need to make during room creation.
export const VERSUS_MAX_PLAYERS = 32

// Lobby clients poll every two seconds. Six seconds gives every connected
// player enough time to receive the start signal without making the host wait.
export const VERSUS_START_DELAY_MS = 6_000

// Active matches use the lightweight status endpoint. A one-second cadence
// keeps the live scoreboard and spectator view feeling immediate without
// repeatedly loading game items or other heavy relations.
export const VERSUS_ACTIVE_POLL_INTERVAL_MS = 1_000
export const VERSUS_SPECTATE_POLL_INTERVAL_MS = 1_000

// The answer reveal already creates a natural pause. A short countdown keeps
// the match moving while still giving players time to refocus.
export const VERSUS_BETWEEN_ROUND_COUNTDOWN_SECONDS = 2
